import { IconButton } from '@mui/material';
import React from 'react';
import { usePageRedirectPath } from 'pages/AppManagement/hooks/UsePageRedirectPath';
import { useHistory } from 'react-router-dom';
import { Icon } from 'components';

const BackButton: React.FC = () => {
  const redirectPath = usePageRedirectPath();
  const history = useHistory();

  return redirectPath ? (
    <IconButton
      onClick={() => {
        history.push(redirectPath);
      }}
    >
      <Icon name="arrow-left-white" size="18" />
    </IconButton>
  ) : (
    <></>
  );
};

export default BackButton;
